import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";

export default function CountrySalesReports() {
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    orderStatus: "All",
    paymentStatus: "All",
  });

  const data = [
    { country: "United Kingdom of Great Britain and Northern Ireland", orders: 2, total: "$2,468.80" },
    { country: "United States of America", orders: 2, total: "$1,957.00" },
    { country: "Canada", orders: 1, total: "$43.50" },
  ];

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <h1 className="text-xl font-semibold text-gray-800 mb-4">Country Sales</h1>

      {/* Search Section */}
      <div className="bg-white p-4 rounded-lg shadow-sm mb-6">
        <div className="flex items-center mb-4 gap-2">
          <FiSearch className="text-gray-500" />
          <span className="text-gray-700 font-medium">Search</span>
        </div>

        {/* Filter Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
          <div>
            <label className="text-sm text-gray-600">Start date</label>
            <input
              type="date"
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.startDate}
              onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
            />
          </div>
          <div>
            <label className="text-sm text-gray-600">End date</label>
            <input
              type="date"
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.endDate}
              onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
            />
          </div>
          <div>
            <label className="text-sm text-gray-600">Order status</label>
            <select
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.orderStatus}
              onChange={(e) => setFilters({ ...filters, orderStatus: e.target.value })}
            >
              <option>All</option>
              <option>Pending</option>
              <option>Completed</option>
              <option>Cancelled</option>
            </select>
          </div>
          <div>
            <label className="text-sm text-gray-600">Payment status</label>
            <select
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.paymentStatus}
              onChange={(e) => setFilters({ ...filters, paymentStatus: e.target.value })}
            >
              <option>All</option>
              <option>Paid</option>
              <option>Unpaid</option>
              <option>Refunded</option>
            </select>
          </div>
        </div>

        {/* Run Report Button */}
        <div className="mt-4">
          <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">
            Run report
          </button>
        </div>
      </div>

      {/* Learn more link */}
      <a
        href="#"
        className="text-blue-600 text-sm hover:underline mb-4 inline-block"
      >
        Learn more about reports
      </a>

      {/* Table Section */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-sm">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="py-3 px-4 font-medium">Country</th>
              <th className="py-3 px-4 font-medium">Number of orders</th>
              <th className="py-3 px-4 font-medium">Order total</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr key={i} className="border-t hover:bg-gray-50">
                <td className="py-3 px-4">{row.country}</td>
                <td className="py-3 px-4">{row.orders}</td>
                <td className="py-3 px-4">{row.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col md:flex-row items-center justify-between mt-4 text-sm text-gray-600">
        <div className="flex items-center gap-2 mb-2 md:mb-0">
          <button className="px-3 py-1 border rounded hover:bg-gray-100">Previous</button>
          <span>1</span>
          <button className="px-3 py-1 border rounded hover:bg-gray-100">Next</button>
        </div>
        <div className="flex items-center gap-2">
          <span>Show</span>
          <select className="border border-gray-300 rounded-md px-2 py-1">
            <option>15</option>
            <option>30</option>
            <option>50</option>
          </select>
          <span>items</span>
        </div>
        <p>1–3 of 3 items</p>
      </div>
    </div>
  );
}
